import { ApplicantViewDto } from '../../applicant/Models';

interface Props {
    applicant: ApplicantViewDto | undefined;
  }

export default function EmailHistory({applicant}:Props) {
  return (
    <div>No email history available</div>
  )
}
